export type CnaeTipo = "servico" | "comercio" | "misto";

export type CnaeMei = {
  slug: string;
  codigo: string;
  nome: string;
  tipo: CnaeTipo;
  permitido: boolean;
  das: number;
  desc: string;
  impostos: string[];
  vantagens: string[];
  riscos: string[];
  relacionados: string[];
  faq: { q: string; a: string }[];
};

export const CNAES_MEI: CnaeMei[] = [
  {
    slug: "designer-grafico",
    codigo: "7410-2/02",
    nome: "Designer Gráfico autônomo",
    tipo: "servico",
    permitido: true,
    das: 76.6,
    desc: "Criação de peças gráficas, logos, materiais visuais e identidade visual para empresas.",
    impostos: [
      "DAS: R$ 76,60/mês fixo",
      "IRPF sobre lucro acima da faixa isenta",
      "Sem ISS adicional (incluso no DAS)",
    ],
    vantagens: [
      "Baixo custo operacional",
      "Alto potencial de faturamento digital",
      "Sem dependência de estoque",
    ],
    riscos: [
      "Atividades de arquitetura vedadas",
      "Publicidade como PJ tem restrições",
      "Limite de R$ 81.000/ano",
    ],
    relacionados: ["Fotógrafo", "Web designer", "Ilustrador digital", "Editor de vídeo"],
    faq: [
      {
        q: "Designer gráfico pode ser MEI em 2026?",
        a: "Sim. A ocupação 'Designer gráfico independente' (CNAE 7410-2/02) está na lista de atividades permitidas para o Microempreendedor Individual, com DAS mensal fixo de R$ 76,60.",
      },
      {
        q: "Posso emitir nota fiscal para empresas como designer MEI?",
        a: "Sim. O MEI designer gráfico emite NFS-e (Nota Fiscal de Serviço Eletrônica) para Pessoa Jurídica e pode prestar serviços recorrentes desde que não configure vínculo empregatício com um único cliente.",
      },
      {
        q: "Qual o limite de faturamento do designer MEI?",
        a: "O limite é R$ 81.000 por ano (cerca de R$ 6.750/mês). Acima disso, o profissional precisa migrar para Microempresa (ME) no Simples Nacional.",
      },
    ],
  },
  {
    slug: "cabeleireiro",
    codigo: "9602-5/01",
    nome: "Cabeleireiro",
    tipo: "servico",
    permitido: true,
    das: 75.6,
    desc: "Serviços de corte, coloração, tratamentos capilares e penteados.",
    impostos: [
      "DAS: R$ 75,60/mês",
      "IRPF se lucro superar isenção",
      "Pode contratar 1 funcionário CLT",
    ],
    vantagens: ["Alta demanda constante", "Clientela fidelizável", "Baixo custo de formalização"],
    riscos: [
      "1 funcionário máximo",
      "Produtos de revenda têm limite",
      "Sede física pode elevar custos",
    ],
    relacionados: ["Manicure", "Maquiadora", "Esteticista", "Barbeiro"],
    faq: [
      {
        q: "Cabeleireiro pode ser MEI?",
        a: "Sim. O CNAE 9602-5/01 (Cabeleireiros, manicure e pedicure) é permitido para MEI, com DAS mensal de R$ 75,60 em 2026, incluindo INSS e ISS.",
      },
      {
        q: "Cabeleireiro MEI pode ter funcionário?",
        a: "Sim, pode contratar 1 empregado registrado em CLT, recebendo piso da categoria ou salário mínimo, com encargos reduzidos pelo Simples Nacional.",
      },
      {
        q: "Preciso de alvará para abrir salão como MEI?",
        a: "Sim. Além do CNPJ MEI, é obrigatório alvará municipal e licença sanitária para atendimento ao público em espaço físico.",
      },
    ],
  },
  {
    slug: "eletricista",
    codigo: "4321-5/00",
    nome: "Eletricista residencial",
    tipo: "servico",
    permitido: true,
    das: 75.6,
    desc: "Instalações elétricas, manutenção e reparos em residências e pequenos comércios.",
    impostos: [
      "DAS: R$ 75,60/mês",
      "IRPF sobre lucro líquido",
      "Sem ISS adicional (incluso no DAS)",
    ],
    vantagens: [
      "Demanda alta e constante",
      "Atende vários locais",
      "Pode atender PJ como subcontratado",
    ],
    riscos: [
      "Responsabilidade técnica civil",
      "Pode exigir ART/CREA em algumas obras",
      "Limite anual de R$ 81 mil",
    ],
    relacionados: ["Encanador", "Ar-condicionado", "Instalador de câmeras", "Pintor"],
    faq: [
      {
        q: "Eletricista pode ser MEI?",
        a: "Sim. O CNAE 4321-5/00 (Instalação e manutenção elétrica) é permitido ao MEI, com DAS de R$ 75,60/mês incluindo INSS, ISS e isenção de outros tributos federais.",
      },
      {
        q: "Eletricista MEI precisa de ART do CREA?",
        a: "Para obras de baixa tensão e reparos simples não. Para projetos elétricos prediais ou industriais, o cliente pode exigir ART (Anotação de Responsabilidade Técnica) emitida por engenheiro.",
      },
      {
        q: "Posso prestar serviço para construtoras sendo MEI?",
        a: "Sim, desde que seja contrato pontual ou por obra. Vínculo exclusivo e contínuo com uma só empresa pode ser interpretado como vínculo trabalhista.",
      },
    ],
  },
  {
    slug: "programador",
    codigo: "6201-5/01",
    nome: "Desenvolvedor de software autônomo",
    tipo: "servico",
    permitido: true,
    das: 75.6,
    desc: "Criação e manutenção de sistemas, aplicativos, sites e automações.",
    impostos: [
      "DAS: R$ 75,60/mês",
      "IRPF sobre lucro acima da faixa isenta",
      "Isento de PIS/Cofins/IPI no DAS",
    ],
    vantagens: [
      "Trabalho 100% remoto",
      "Pode atender clientes internacionais",
      "Alta margem de lucro",
    ],
    riscos: [
      "Prestar para 1 só cliente pode gerar vínculo",
      "Limite de R$ 81 mil/ano atinge rápido",
      "Consultoria de TI é diferente de desenvolvimento",
    ],
    relacionados: ["Designer UX/UI", "Analista de dados", "Gestor de tráfego", "Suporte técnico"],
    faq: [
      {
        q: "Programador pode ser MEI?",
        a: "Sim. A ocupação 'Programador autônomo' (CNAE 6201-5/01) é permitida ao MEI, com DAS mensal de R$ 75,60 em 2026 e isenção de PIS, Cofins e IPI.",
      },
      {
        q: "Posso atender clientes no exterior como programador MEI?",
        a: "Sim. A exportação de serviços de software é permitida, mas o valor recebido em moeda estrangeira conta no limite anual de R$ 81.000 após conversão para real.",
      },
      {
        q: "Programador MEI corre risco de vínculo empregatício?",
        a: "Sim, se prestar serviço com exclusividade, horário fixo e subordinação a uma única empresa. Diversifique a carteira para reduzir o risco de reconhecimento de vínculo.",
      },
    ],
  },
  {
    slug: "lanchonete",
    codigo: "5611-2/01",
    nome: "Lanchonete e similares",
    tipo: "misto",
    permitido: true,
    das: 71.6,
    desc: "Preparo e comercialização de lanches, refeições rápidas, salgados e bebidas.",
    impostos: [
      "DAS: R$ 71,60/mês (misto)",
      "Inclui ICMS + ISS no DAS",
      "IRPF sobre lucro se aplicável",
    ],
    vantagens: ["Modelo de negócio testado", "Clientela local fidelizável", "Pode vender delivery"],
    riscos: [
      "Vigilância sanitária obrigatória",
      "Limite de estoque de bebidas alcoólicas",
      "1 funcionário máximo",
    ],
    relacionados: ["Confeiteiro", "Doceiro", "Pizzaria delivery", "Marmitex"],
    faq: [
      {
        q: "Lanchonete pode ser MEI?",
        a: "Sim. O CNAE 5611-2/01 (Lanchonetes, casas de chá, sucos e similares) é permitido ao MEI, com DAS mensal de R$ 71,60 incluindo INSS, ICMS e ISS.",
      },
      {
        q: "Lanchonete MEI pode vender bebida alcoólica?",
        a: "Sim, em pequena escala como complemento ao serviço. Vendas com volume relevante exigem migração para Microempresa e alvará específico.",
      },
      {
        q: "Preciso de vigilância sanitária para lanchonete MEI?",
        a: "Sim. Toda atividade de manipulação de alimentos exige licença sanitária municipal e curso de boas práticas, mesmo no MEI.",
      },
    ],
  },
  {
    slug: "vendedor-roupas",
    codigo: "4781-4/00",
    nome: "Comércio de vestuário e acessórios",
    tipo: "comercio",
    permitido: true,
    das: 71.6,
    desc: "Venda de roupas, calçados, bolsas e acessórios de moda em geral.",
    impostos: ["DAS: R$ 71,60/mês", "Inclui ICMS no DAS", "Emissão de NF obrigatória para PJ"],
    vantagens: ["Pode vender online (e-commerce)", "Mercado aquecido", "Trabalho em casa possível"],
    riscos: [
      "Estoque conta para o limite de faturamento",
      "Importação direta tem regras específicas",
      "Precisa de NF para compras",
    ],
    relacionados: ["Artesanato", "Bijuterias", "Calçados", "Moda praia"],
    faq: [
      {
        q: "Vendedor de roupas pode ser MEI?",
        a: "Sim. O CNAE 4781-4/00 (Comércio varejista de vestuário e acessórios) é permitido ao MEI, com DAS de R$ 71,60/mês incluindo ICMS.",
      },
      {
        q: "Posso vender roupa online como MEI?",
        a: "Sim. E-commerce de moda é permitido. É necessário emitir nota fiscal eletrônica (NF-e) em vendas para outros estados e PJ.",
      },
      {
        q: "Importar roupa para revender é permitido para MEI?",
        a: "Sim, mas com limite anual de US$ 50.000 em importação. Acima disso é necessário habilitação no Radar/Siscomex e migração para ME.",
      },
    ],
  },
  {
    slug: "motoboy",
    codigo: "5320-2/02",
    nome: "Entregador (motoboy / mototaxista)",
    tipo: "servico",
    permitido: true,
    das: 75.6,
    desc: "Serviços de entrega rápida de pequenos volumes e documentos por motocicleta.",
    impostos: ["DAS: R$ 75,60/mês", "ISS incluso no DAS", "IRPF sobre lucro acima do isento"],
    vantagens: [
      "Pode trabalhar via apps de entrega",
      "Sem ponto fixo",
      "Demanda constante em capitais",
    ],
    riscos: [
      "Vínculo empregatício se exclusivo de 1 app",
      "INSS acidente requer complementação",
      "Custos com moto e combustível",
    ],
    relacionados: ["Mototaxista", "Moto-frete", "Transporte de cargas leves"],
    faq: [
      {
        q: "Motoboy pode ser MEI?",
        a: "Sim. O CNAE 5320-2/02 (Serviços de entrega rápida) é permitido ao MEI, com DAS de R$ 75,60/mês incluindo INSS e ISS.",
      },
      {
        q: "Posso trabalhar para apps como iFood sendo MEI?",
        a: "Sim, e é a forma mais comum. Recomenda-se atuar em mais de um app para evitar caracterização de vínculo empregatício com uma única plataforma.",
      },
      {
        q: "Motoboy MEI tem direito a auxílio-acidente?",
        a: "Tem auxílio por incapacidade temporária após 12 meses de contribuição. Para benefício mais robusto em caso de acidente, recomenda-se INSS complementar.",
      },
    ],
  },
  {
    slug: "costureira",
    codigo: "1412-6/02",
    nome: "Costureira sob encomenda",
    tipo: "misto",
    permitido: true,
    das: 71.6,
    desc: "Confecção, ajustes e reformas de roupas sob encomenda do cliente.",
    impostos: ["DAS: R$ 71,60/mês (misto)", "ICMS + ISS inclusos no DAS"],
    vantagens: ["Pode trabalhar em casa", "Clientela fidelizável", "Baixo investimento inicial"],
    riscos: ["Sazonalidade", "Tempo de produção limita faturamento", "1 funcionário máximo"],
    relacionados: ["Confecção", "Bordado", "Artesanato têxtil"],
    faq: [
      {
        q: "Costureira pode ser MEI?",
        a: "Sim. O CNAE 1412-6/02 (Confecção sob medida de peças de vestuário) é permitido ao MEI, com DAS de R$ 71,60/mês incluindo INSS, ICMS e ISS.",
      },
      {
        q: "Costureira MEI pode vender roupas prontas?",
        a: "Sim, desde que seja produção própria sob encomenda. Para revenda em larga escala de roupas industrializadas, use o CNAE 4781-4/00 (comércio de vestuário).",
      },
      {
        q: "Posso trabalhar de casa como costureira MEI?",
        a: "Sim. A atividade de confecção sob medida é permitida no endereço residencial, sem necessidade de alvará comercial em muitos municípios.",
      },
    ],
  },
];

export function getCnaeBySlug(slug: string): CnaeMei | undefined {
  return CNAES_MEI.find((c) => c.slug === slug);
}

export const tipoLabel = (t: CnaeTipo) =>
  t === "servico" ? "Serviço" : t === "comercio" ? "Comércio" : "Misto (Com.+Serv.)";
